import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { isNull } from 'lodash-es';
import { ListingTimeline, ListingTimelineable } from 'app/models/listing-timeline';
import { ListingsService } from 'app/services/listings.service';
import Pin from 'app/models/pin';
import { map, tap } from 'rxjs/operators';
import Listable from 'app/mixins/listable';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';

class ListableListingTimeline extends Listable(ListingTimeline) { }

@Component({
  selector: 'listing-map-pin',
  templateUrl: './listing-map-pin.component.html',
  styleUrls: ['./listing-map-pin.component.scss']
})
export class ListingMapPinComponent implements OnInit {
  @Input('pin') pin: Pin;
  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;
  @ViewChild(MapMarker) marker: MapMarker;

  selectedListing: ListableListingTimeline;
  pinCoordinates: google.maps.LatLngLiteral;

  markerOptions: google.maps.MarkerOptions = {
    draggable: false,
  };

  constructor(private listingsService: ListingsService) { }

  ngOnInit() {
    this.pinCoordinates = { lat: this.pin.latitude, lng: this.pin.longitude };
    this.markerOptions.zIndex = this.pin.pin_z_index;
    this.markerOptions.icon = 'assets/houwzer/pins/' + this.pin.pin_image_filename;
  }

  showPin(timeline_id: number) {
    this.listingsService.getListing(timeline_id)
      .pipe(
        tap((listingTimelineable: ListingTimelineable) => {
          this.selectedListing = new ListableListingTimeline(listingTimelineable)
        })
      ).subscribe(() => {
        this.infoWindow.open(this.marker);
      });

  }

  headlineText() {
    return [
      this.selectedListing.price(),
      this.selectedListing.status()
    ]
      .filter(text => !isNull(text))
      .join(' - ')
  }
}
